import { Fragment } from 'react';
interface Props {
  title: string;
  sub?: string;
  titleClass?: string;
}
export const Heading = ({ title, sub, titleClass }: Props) => {
  return (
    <Fragment>
      <h2
        className={`lil-py-2 ${
          titleClass ? titleClass : 'lil-text-s-56 sm:lil-text-s-32'
        }`}
      >
        {title}
      </h2>
      {sub ? <p>{sub}</p> : null}
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./components/common/heading.tsx